import imgSmileUps from '../../assets/images/smileUps.png';
import { BackErrorImgPngType, BackErrorType } from '../../types/Types';
import { ErrorCodeConstants } from '../../utils/ErrorCodeConstants';

export const FIDELIO_CUSTOMER_RECORD_BLOCKED_ERROR_CODE =
  ErrorCodeConstants.FIDELIO_CUSTOMER_RECORD_BLOCKED_EXCEPTION;

export const isFidelioCustomerRecordBlocked = (error?: BackErrorType) =>
  error?.errorCode === FIDELIO_CUSTOMER_RECORD_BLOCKED_ERROR_CODE;

export const getFidelioCustomerRecordBlockedError = (
  phone: string,
): BackErrorImgPngType => ({
  errorCode: FIDELIO_CUSTOMER_RECORD_BLOCKED_ERROR_CODE,
  title: [{ key: 'titulo-error-servicios-caidos', arguments: [] }],
  userMessage: [
    { key: 'cuerpo-reintento-error-caidos-tlf', arguments: [phone] },
  ],
  imgPng: imgSmileUps,
});
